module.exports = __webpack_public_path__ + "static/media/tempestade.ff87cbae.jpg";